import { createFileRoute, useParams } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { trpc } from '@/lib/trpc'

function TaskDetail() {
  const { taskId } = useParams({ from: '/(protected)/workspaces/$workspaceId/tasks/$taskId' })
  const queryOptions = trpc.tasks.getById.queryOptions({ id: taskId })
  const { data, isLoading, error } = useQuery(queryOptions)

  if (isLoading) return <div className='p-4 text-sm text-muted-foreground'>Loading…</div>
  if (error) return <div className='p-4 text-sm text-red-500'>Failed to load task.</div>
  if (!data) return null

  return (
    <div className='p-4 space-y-4'>
      <div className='space-y-1'>
        <div className='text-xs text-muted-foreground'>Type</div>
        <div className='text-base font-semibold'>{data.type}</div>
      </div>
      <div className='space-y-1'>
        <div className='text-xs text-muted-foreground'>Title</div>
        <div>{data.text}</div>
      </div>
      <div className='grid grid-cols-2 gap-4'>
        <div>
          <div className='text-xs text-muted-foreground'>Assignee</div>
          <div>{data.assignedTo ? (data.assignedTo.name || data.assignedTo.email) : 'Unassigned'}</div>
        </div>
        <div>
          <div className='text-xs text-muted-foreground'>Priority</div>
          <div>{data.priority}</div>
        </div>
        <div>
          <div className='text-xs text-muted-foreground'>Status</div>
          <div>{data.taskStatus}</div>
        </div>
        <div>
          <div className='text-xs text-muted-foreground'>Due</div>
          <div>{data.dueDate ? new Date(data.dueDate).toLocaleString() : '—'}</div>
        </div>
      </div>
      <div className='grid grid-cols-2 gap-4'>
        <div>
          <div className='text-xs text-muted-foreground'>Doc</div>
          <div>{data.doc ? data.doc.title : '—'}</div>
        </div>
        <div>
          <div className='text-xs text-muted-foreground'>Source</div>
          <div>{(data as any).sourceRef ? (data as any).sourceRef.name : '—'}</div>
        </div>
      </div>
      {/* Thread display placeholder */}
      <div>
        <div className='text-xs text-muted-foreground mb-1'>Thread</div>
        <div className='rounded border p-3 text-sm bg-card'>
          {data.replies?.length ? `${data.replies.length} replies` : 'No replies'}
        </div>
      </div>
    </div>
  )
}

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/tasks/$taskId')({
  component: TaskDetail,
})

